import { render, staticRenderFns } from "./LogosSection.vue?vue&type=template&id=6c59ab9c&scoped=true&"
import script from "./LogosSection.vue?vue&type=script&lang=ts&"
export * from "./LogosSection.vue?vue&type=script&lang=ts&"
import style0 from "./LogosSection.vue?vue&type=style&index=0&id=6c59ab9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c59ab9c",
  null
  
)

export default component.exports